export default {"src":"/_next/static/media/GromoLogo.f6c2f6dc.svg","height":152,"width":452};